@if (languageService.activeLanguage()) {
  <div mdbDropdown class="btn-group shadow-0" style="max-height: 30px">
    <button
      type="button"
      class="btn btn-link dropdown-toggle p-0"
      mdbDropdownToggle
      style="width: 100px"
      aria-expanded="false">
      @if (showNames()) {
        <span>{{ (languageService.activeLanguage()!.name|language).name }}</span>
      }
      @if (!showNames()) {
        @if (languageService.activeLanguage()!.imagePath) {
          <img
            class="object-fit-contain px-2"
            style="max-height: 100%; max-width: 100%;"
            src="{{ environment.apiFileUrl + languageService.activeLanguage()!.imagePath }}"
            alt="{{languageService.activeLanguage()!.code}}"/>
        } @else {
          <span>{{ languageService.activeLanguage()!.code }}</span>
        }
      }
    </button>
    <ul mdbDropdownMenu class="dropdown-menu">
      @for (language of languageService.notActiveLanguages(); track language.id) {
        <li
          (click)="changeLanguage(language)"
          style="cursor: pointer">
          <a class="dropdown-item p-0 text-center" style="max-width: 100%; width: auto; height: 30px;">
            @if (showNames()) {
              <span>{{ (language.name|language).name }}</span>
            }
            @if (!showNames()) {
              @if (language.imagePath) {
                <img
                  src="{{ environment.apiFileUrl + language.imagePath }}"
                  alt="{{language.code}}"
                  style="max-height: 100%; max-width: 100%"/>
              } @else {
                <span>{{ language.code }}</span>
              }
            }
          </a>
        </li>
      }
    </ul>
  </div>
}
